import React from "react"
import styled from "styled-components"

import { Typography } from "@material-ui/core"
import IoAnimator from "../IoAnimator"

import * as theme from "../../theme"

const ContactInfo = ({ headline, address, phone, email }) => {
  return (
    <Container>
      {!!headline && (
        <Headline variant="h1" gutterBottom>
          {headline}
        </Headline>
      )}
      <Grid>
        {!!address &&
          address.map(({ name, street, province, postal }, index) => {
            return (
              <Item key={index}>
                <Typography variant="h5" gutterBottom>
                  {name}
                </Typography>
                <a
                  href={
                    "https://www.google.com/maps/search/?api=1&query=" +
                    street.concat("+", province, "+", postal)
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography color="inherit">{street}</Typography>
                  <Typography color="inherit">{province}</Typography>
                  <Typography color="inherit">{postal}</Typography>
                </a>
              </Item>
            )
          })}

        {!!phone && (
          <Item>
            <Typography variant="h5" gutterBottom>
              Telephone
            </Typography>
            <a href={"tel:" + phone}>
              <Typography color="inherit">{phone}</Typography>
            </a>
          </Item>
        )}
        {!!email && (
          <Item>
            <Typography variant="h5" gutterBottom>
              Email Address
            </Typography>
            <a href={"mailto:" + email}>
              <Typography color="inherit">{email}</Typography>
            </a>
          </Item>
        )}
      </Grid>
    </Container>
  )
}

export default ContactInfo

const Container = styled(IoAnimator)`
  @media (min-width: 1050px) {
    flex-direction: row;
  }
  @media (min-width: 800px) {
    padding-bottom: 60px;
  }
  padding-bottom: 30px;
  flex-direction: column;
  display: flex;
`
const Headline = styled(Typography)`
  color: ${theme.color.primary};
  @media (min-width: 650px) {
    padding: 0 40px;
  }
  padding: 0 5%;
`
const Item = styled.div`
  @media (min-width: 650px) {
    padding: 0 40px;
  }
  padding: 20px 5%;
  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      color: ${theme.color.primary};
    }
  }
`
const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: 650px) {
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 50px;
    grid-template-columns: 1fr 1fr;
  }
`
